import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";

import { AppCard } from "components/appComponents";
import { useGetEmployeeSalaryDetailQuery } from "bus/employeeSalary/services/services";

type Props = {
  employeeId: number;
  dateBegin: string;
  dateEnd: string;
}

const SalaryEmployeeInfoTable = React.forwardRef<any, Props>(
  ({
    dateBegin,
    dateEnd,
    employeeId
  }, ref) => {
    const { data } = useGetEmployeeSalaryDetailQuery({
      dateBegin,
      dateEnd,
      employeeId
    });


    return (
      <div className="container-dev">
        <AppCard>
          <DataGrid
            dataSource={data?.data || []}
            showBorders={false}
            loadPanel={{
              enabled: true,
              text: "Загрузка",
            }}
            key="id"
            ref={ref}
          >
            <FilterRow visible={true} />
            <Column
              dataField="date"
              caption="Дата"
              dataType="date"
              sortOrder="asc"
              width={140}
            />
            <Column dataField="objectName" caption="Объект" />
            <Column dataField="price" caption="Ставка" />
            <Column dataField="toPay" caption="К оплате, руб" />
            <Column dataField="adjustments" caption="Корректировка" />
            <Column dataField="cashFlow" caption="Касса" />

            <Summary>
              <TotalItem
                column="price"
                summaryType="sum"
                displayFormat="Итого: {0}"
              />
              <TotalItem
                column="toPay"
                summaryType="sum"
                displayFormat="Итого: {0}"
              />
              <TotalItem
                column="adjustments"
                summaryType="sum"
                displayFormat="Итого: {0}"
              />
              <TotalItem
                column="cashFlow"
                summaryType="sum"
                displayFormat="Итого: {0}"
              />
            </Summary>
          </DataGrid>
        </AppCard>
      </div>
    );
  }
);

export default SalaryEmployeeInfoTable;
